AppTabs.createTab( {
name: 'analyte-management',
icon: 'vial',
text: 'Analyte Management',
create: function(init) {
	'use strict'

	const tab = this;

	const fields = [
		{
			label: 		'Analyte',
			columnName: 'AnalyteId',
			isEditable: true,
			type:		'analyte',
			render: 	DataTablesManager.getAnalyteNameByID,
			sort:		'asc',
		},
		{
			label: 		'Test',
			columnName: 'TestId',
			isEditable: true,
			type:		'test',
			render: 	DataTablesManager.getTestNameByID,
			sort:		'asc',
		},
		{
			label: 		'DNR Report Number/Identifier',
			columnName: 'ParameterCode',
			isEditable: true,
			type:		'number'
		},
		{
			label: 		'Media',
			columnName: 'Media',
			isEditable: true,
			type:		'text'
		},
		{
			label: 		'Analysis Type',
			columnName: 'AnalysisType',
			isEditable: true,
			type:		'text'
		},

	];

	init.setDataTableArgs( {

		tableId: 		'#data-table-analyte-management',

		readTableName: 	'viewanalytes',
		editTableName: 	'tblAnalyteTests',
		primaryKey: 	'id',

		hasColumnFilters: 	true,
		canSearch: 			true,
		canRemove: 			true,
		canSort:			true,

		actionData:			'datatable',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'analyteOptions' );
		},

		fields: fields

	} );

	
	let loaded = false;
	init.setController( {
		onOpenTab() {
			if ( loaded ) {
				tab.drawTable();
				return;
			}
			window.LocalStorageManager.loadField('analyteOptions').then( tab.drawTable );
			loaded = true;
		},
	} );
}

} );
